// Ukrainian display labels for LessonRescheduleMessage.actionType - platform
// treats `action` as an open string with a label lookup + raw fallback (per
// backend's own PlatformRescheduleMessageView comment), CRM mirrors that
// same "unknown action types don't break rendering" approach.
export const RESCHEDULE_ACTION_LABELS = {
   PROPOSED: 'Запропонував(ла) новий час',
   VOTED_ACCEPT: 'Погодився(лась)',
   VOTED_ALTERNATIVE: 'Запропонував(ла) інший варіант',
   SENT_TO_TEACHER: 'Надіслано вчителю',
   TEACHER_COUNTER_OFFER: 'Вчитель запропонував інший час',
   TEACHER_PROPOSED_TIME: 'Вчитель змінив час заняття',
   TEACHER_DECLINED: 'Вчитель відхилив запит',
   STUDENT_ACCEPTED_FINAL: 'Підтвердив(ла) новий час',
};

export function rescheduleActionLabel(action) {
   return RESCHEDULE_ACTION_LABELS[action] || action;
}

export const RESCHEDULE_STATUS_LABELS = {
   AWAITING_STUDENT_CONSENSUS: 'Учні ще узгоджують час між собою',
   PENDING_TEACHER: 'Очікує на вашу відповідь',
   TEACHER_COUNTER_OFFERED: 'Ви запропонували інший час - очікуємо підтвердження',
   TEACHER_PROPOSED_TIME: 'Ви змінили час заняття - очікуємо підтвердження',
   DECLINED: 'Відхилено - заняття залишається на старому часі',
   ACCEPTED: 'Погоджено',
};

export function rescheduleStatusLabel(status) {
   return RESCHEDULE_STATUS_LABELS[status] || status;
}
